/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".blinking-image[_ngcontent-%COMP%]{top:0;left:0;opacity:1;-webkit-animation:2s infinite alternate blink;animation:2s infinite alternate blink}@-webkit-keyframes blink{0%,100%{opacity:1}50%{opacity:0}}@keyframes blink{0%,100%{opacity:1}50%{opacity:0}}.no-data-container[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;width:100%;height:calc(100% - 27px);position:relative;top:30px}"];
export { styles as styles };
